import {Directive, ElementRef, EventEmitter, HostListener, Input, NgZone, OnDestroy, Output} from '@angular/core';

@Directive({ selector: '[insCloseListOnScroll]' })
export class CloseListOnScrollDirective implements OnDestroy {

  @Input() set insCloseListOnScroll(active: boolean) {
    this.isActive = active;
    active ? this.attach() : this.detach();
  }

  @Output() readonly insListClosedOnScroll = new EventEmitter<void>();

  @HostListener('window:resize')
  onWindowResize(): void {
    if (this.isActive) {
      this.insListClosedOnScroll.emit();
    }
  }

  private scrollParent: HTMLElement | null = null;
  private resizeObserver: ResizeObserver | null = null;
  private readonly onScrollFn: () => void;
  private isActive = false;

  constructor(private readonly elRef: ElementRef, private readonly ngZone: NgZone) {
    this.onScrollFn = () => this.ngZone.run(() => this.insListClosedOnScroll.emit());
  }

  private attach(): void {
    this.scrollParent = this.getScrollParent(this.elRef.nativeElement);
    this.scrollParent.addEventListener('scroll', this.onScrollFn, { passive: true });
    let initialFired = false;
    this.resizeObserver = new ResizeObserver(() => {
      if (!initialFired) { initialFired = true; return; }
      this.ngZone.run(() => this.insListClosedOnScroll.emit());
    });
    this.resizeObserver.observe(this.scrollParent);
  }

  private detach(): void {
    if (this.scrollParent) {
      this.scrollParent.removeEventListener('scroll', this.onScrollFn);
      this.scrollParent = null;
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  }

  private getScrollParent(el: HTMLElement): HTMLElement {
    let parent = el.parentElement;
    while (parent && parent !== document.body) {
      const style = getComputedStyle(parent);
      if (/auto|scroll/.test(style.overflow + style.overflowY)) {
        return parent;
      }
      parent = parent.parentElement;
    }
    return document.documentElement;
  }

  ngOnDestroy(): void {
    this.detach();
  }
}
